<template>
    <slot name="wrapper"></slot>
    <div class="modal fade" :id="name">
        <div :class="`modal-dialog modal-${size}`">
            <div class="modal-content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>

export const ModalHeader = require("./ModalHeader").default;
export const ModalTitle = require("./ModalTitle").default;
export const ModalBody = require("./ModalBody").default;
export const ModalFooter = require("./ModalFooter").default;

export default {
    name: "Modal",
    emits: ['onShow', 'onDismiss', 'onFirstOpen'],
    props: {
        open: {required: false, type: Boolean, default: false},
        name: {required: false, type: String, default: 'modal'},
        size: {required: false, type: String, default: 'md'},
    },
    data() {
        return {
            isOpen: this.open,
            isOpened: false,
        }
    },
    methods: {
        dismiss() {
            this.isOpen = false;
            this.$emit('onDismiss');
        },
        show() {
            this.isOpen = true;
            this.$emit('onShow');
        },
        opened() {
            this.$emit('onFirstOpen');
        }
    },
    watch: {
        open(value) {
            this.isOpen = value;
        },
        isOpen(value) {
            if (value) {
                this.isOpened = true;
            }
            if(value){
                jQuery(`#${this.name}`).modal({ backdrop: 'static', keyboard: false }).modal('show');
            }else{
                jQuery(`#${this.name}`).modal('hide');
            }
        },
        isOpened(value) {
            if (value) {
                this.opened();
            }
        }
    },
    mounted() {
        if (this.open) {
            this.isOpen = true;
        }
    }
}
</script>

<style scoped>

</style>
